var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',{staticClass:"section-title mb-3",attrs:{"id":"sectionTitle"}},[_vm._v(" Company Information ")]),_c('CreditInfo',{attrs:{"app":_vm.app}}),_c('CompanyInfo',{attrs:{"app":_vm.app,"can-edit":_vm.identity.permissions.editApplications},on:{"editCompanyInfo_":function($event){return _vm.editCompanyInfo()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }